'use client';
const MANIFEST_ILLUSTRATIONS = {
    generic: {
        hashed: 'generic.f1f362f7c606d59ebfa6959120362279.svg',
        versioned: 'generic.svg'
    }
};

export { MANIFEST_ILLUSTRATIONS };
